import React, { useState, useEffect } from "react";
// import "./AirdropCountdown.css"; // Import the CSS file

const AirdropCountdown = () => {
    // Function to get time remaining until the next airdrop
    const getNextAirdropTime = () => {
        const now = new Date();
        const nextAirdrop = new Date();
        nextAirdrop.setHours(24, 0, 0, 0); // Reset to next 24-hour cycle
        if (now.getHours() >= 24) {
            nextAirdrop.setDate(nextAirdrop.getDate() + 1);
        }
        return nextAirdrop.getTime();
    };

    const [timeLeft, setTimeLeft] = useState(getNextAirdropTime() - Date.now());

    useEffect(() => {
        const timer = setInterval(() => {
            const remaining = getNextAirdropTime() - Date.now();
            setTimeLeft(remaining > 0 ? remaining : 0);
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    // Convert milliseconds to HH:MM:SS format
    const formatTime = (ms) => {
        const totalSeconds = Math.floor(ms / 1000);
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
        const seconds = String(totalSeconds % 60).padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
    };

    return (
        <div className="text-center text-md-start">
            <span className="h3 text-light px-md-5">
                Your Next Staking Airdrop in{" "}
                <span className="countdown-time px-2">{formatTime(timeLeft)}</span>
            </span>
        </div>
    );
};

export default AirdropCountdown;
